<script>
  import { onMount } from "svelte";
  import { ICONS } from "../js/icons";
  import backend from "../server";

  import moment from "moment";
  import ShowDetalls from "../lib/components/modals/freebets/barbara/ShowDetalls.svelte";
  import FormBarbara from "../lib/components/modals/freebets/barbara/Form.svelte";

  let currentPage = 1;
  let filters = {
    page: currentPage,
    limit: 500,
    code: "431",
    provider: "bbb",
    brand: "BARBARA BANG",
    provider_id: "",
    type: "",
    is_bonus_money: "",
    status: "",
  };
  let isNew = false;
  let campaigns = [];
  let isLoading = true;

  let showFilters = false;
  let campaign = null;
  let showDetalls = false;
  let offerId = "";

  let bonuses = {
    accountId: 431,
    game: "",
    userId: "",
    username:"",
    offerId: generateOfferId(),
    expiredAt: moment("YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
    settings: {
      currency: "",
      bet: "",
      count: "",
    },
  };

  function generateOfferId() {
    const fixedPart = "57348"; // Parte fija
    const randomPart = Math.floor(Math.random() * (999 - 100 + 1)) + 100; // Número aleatorio entre 100 y 999
    return `${fixedPart}${randomPart}`;
  }

  onMount(async () => {
    await listCampaign();
  });

  const searchEnter = (e) => {
    if (e.charCode === 13);
  };

  const listCampaign = async () => {
    let params = { ...filters };
    isLoading = true;
    try {
      let response = await backend.freespin.getBarBaragBang(params);
      campaigns = response.data.data;
    } catch (error) {
      console.error("Error al obtener las campañas:", error);
    } finally {
      isLoading = false;
    }
  };

  const created = () => {
    campaign = { ...bonuses };
    isNew = true;
  };
  const detalls = (campaignId) => {
    console.log(campaignId);

    showDetalls = true;
    offerId = campaignId;
  };

  const toggleFilters = () => {
    showFilters = !showFilters;
  };
  const desactive = async (campaignId) => {
  const confirmMessage = `¿Estás seguro de desactivar a ${campaignId}?`;
  if (!confirm(confirmMessage)) {
    console.log("Operación cancelada por el usuario.");
    return; // Sale si el usuario no confirma
  }

  console.log("No se encontró la campaña con ID:", campaignId);

  const sendData = {
    accountId: bonuses.accountId,
    offerId: campaignId,
  };
  console.log("send-data : ", sendData);

  try {
    const response = await backend.freespin.desactiveBarbaraBang(sendData);

    const success = response?.data?.success;
    const message = response?.data?.message;

    if (success) {
      console.log("✅ Freespin desactivado correctamente");
      listCampaign();
    } else {
      console.warn("⚠️ No se pudo desactivar:", message || "Error desconocido");
    }
  } catch (error) {
    console.error("Error al desactivar:", error);
  }
};

</script>

<div class="wrapp">
  <div class="menu-filter">
    <div
      style="display: flex; flex-direction: row; gap: 0.5rem; margin-top: 1rem;"
    >
      <input
        on:keypress={searchEnter}
        bind:value={filters.search}
        class="form-control"
        placeholder="Buscar"
        style="flex: 1;"
      />
      <button
        on:click={listCampaign}
        class="btn btn-pink btn-sm"
        title="Buscar"
        disabled={isLoading}
      >
        {#if isLoading}
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span> Cargando...
        {:else}
          {@html ICONS.search}
        {/if}
      </button>
      <button class="btn btn-pink btn-sm" on:click={created}>
        {@html ICONS.add}
      </button>
      <button class="btn btn-pink btn-sm" on:click={toggleFilters}>
        <i
          class="fa-solid {showFilters
            ? 'fa-filter-circle-xmark'
            : 'fa-filter'}"
        ></i>
      </button>
    </div>
  </div>
</div>

<div class="wrapp">
  <div class="menu-filter">
    {#if showFilters}
      <div class="filters-container">
        <div class="row">
          <div class="col-md-4">
            <label for="id">ID</label>
            <input
              type="number"
              id="id"
              bind:value={filters.id}
              class="form-control"
              placeholder="ID de campaña"
            />
          </div>
          <div class="col-md-4">
            <label for="client_campaign_title">Título de campaña</label>
            <input
              type="text"
              id="client_campaign_title"
              bind:value={filters.client_campaign_title}
              class="form-control"
              placeholder="Título"
            />
          </div>
          <div class="col-md-4">
            <label for="player_count">Número de jugadores</label>
            <input
              type="number"
              id="player_count"
              bind:value={filters.player_count}
              class="form-control"
              placeholder="Jugadores"
            />
          </div>
        </div>
      </div>
    {/if}
  </div>
</div>

<div class="wrapp">
  <div class="container-table">
    <div style="overflow-x: auto;">
      {#if isLoading}
        <p>Cargando...</p>
      {:else if campaigns.length === 0}
        <p>No hay datos</p>
      {:else}
        <table class="table table-sm">
          <thead>
            <tr>
              <th>Código</th>
              <th>Proveedor</th>
              <th>Marca</th>
              <th>Campaña ID (offerId)</th>
              <th>Juego - usuario </th>
              <th>Fecha de inicio</th>
              <th>Estado</th>
              <th>Fecha de fin</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {#each campaigns as item}
            <tr>
              <td>{item.code}</td>
              <td>{item.provider}</td>
              <td>{item.brand}</td>
              <td>{item.campaignId}</td>
              <td>{item.comments || ''}</td>
              <td>{moment(item.startDate).format("YYYY-MM-DD HH:mm")}</td>
              <td>{item.status == 1 ? 'activo' : 'desactivo'}</td>
              <td>{moment(item.endDate).format("YYYY-MM-DD HH:mm")}</td>
              <td>
                <div class="button-container">
                  <button
                    on:click={() => detalls(item.campaignId)}
                    class="btn btn-secondary btn-sm"
                  >
                    {@html ICONS.eye}
                  </button>

                  {#if item.status === 1}
                    <button
                      on:click={() => desactive(item.campaignId)}
                      class="btn btn-warning btn-sm"
                    >
                      <i class="fa-solid fa-toggle-on"></i>
                    </button>
                  {/if}
                </div>
              </td>
            </tr>
          {/each}

          </tbody>
        </table>
      {/if}
    </div>
  </div>
</div>
{#if isNew || campaign}
  <FormBarbara bind:isNew bind:campaign {listCampaign} />
{/if}
{#if showDetalls}
  <ShowDetalls bind:showDetalls bind:offerId />
{/if}

<style>
  .menu-filter {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 0.5rem;
  }

  .container-table {
    padding: 0.5rem;
  }

  .btn-pink {
    background-color: #2a1a28;
    color: white;
  }
  .btn-pink:hover {
    background-color: #ff0090;
    color: white;
  }
  .wrapp {
    padding: 10px;
    margin: 0;
  }

  .menu-filter {
    margin: 0;
    padding: 0;
  }

  .filters-container {
    margin-top: 1rem;
    border: 1px solid #ddd;
    padding: 1rem;
    border-radius: 5px;
  }
</style>
